// ===== utilidades comunes =====
function fixTxtHeight($txt) {
    const slick = $txt.slick('getSlick');
    if (!slick) return;
    const $cur = $(slick.$slides[slick.currentSlide]);
    $(slick.$list).height($cur.outerHeight(true));
}

function reflowAndSync($scope) {
    const $img = $scope.find('.vImgSlides.slick-initialized').first();
    const $txt = $scope.find('.vTxtSlides.slick-initialized').first();
    if (!$img.length || !$txt.length) return;

    const current = $txt.slick('getSlick').currentSlide || 0;

    requestAnimationFrame(() => {
        $img.slick('setPosition').slick('refresh').slick('resize');
        $txt.slick('setPosition').slick('refresh').slick('resize');
        $img.slick('slickGoTo', current, true);
        $txt.slick('slickGoTo', current, true);

        const $activeImg = $img.find('.slick-active img[data-lazy]');
        $activeImg.each(function () {
            const u = this.getAttribute('data-lazy');
            if (u) { this.src = u; this.removeAttribute('data-lazy'); }
        });

        setTimeout(() => {
            $img.slick('setPosition');
            $txt.slick('setPosition');
            fixTxtHeight($txt);
        }, 0);
    });
}

// ===== helpers para flechas =====
function ensureArrowLabel($btn) {
    // crea <span class="arrow-label"> si no existe
    if (!$btn.find('.arrow-label').length) {
        $btn.append('<span class="arrow-label"></span>');
    }
    return $btn.find('.arrow-label');
}

function setArrow($btn, enabled, label) {
    const $lbl = ensureArrowLabel($btn);

    $lbl.text(label || '');

    if (label) {
        $btn.attr('aria-label', label).attr('title', label);
    } else {
        $btn.removeAttr('aria-label').removeAttr('title');
    }

    if (enabled) {
        $btn
            .show()
            .prop('disabled', false)
            .removeAttr('disabled')
            .removeClass('slick-disabled')
            .attr('aria-disabled', 'false');
    } else {
        $btn
            .hide()
            .prop('disabled', true)
            .attr('disabled', 'disabled')
            .addClass('slick-disabled')
            .attr('aria-disabled', 'true');
    }
}

function updateArrowsState($txt, $controls) {
    const slick = $txt.slick('getSlick');
    if (!slick) return;

    const $prev = $controls.find('.slide-m-prev');
    const $next = $controls.find('.slide-m-next');

    const i = slick.currentSlide || 0;
    const last = slick.slideCount - 1;

    if (slick.slideCount <= 1) {
        $controls.hide();
        return;
    }

    $controls.show();

    function getSlideTitle(idx) {
        if (idx < 0 || idx > last) return '';

        const $slide = $(slick.$slides[idx]);
        const fromData = $slide.find('[data-title]').first().attr('data-title');

        if (fromData && String(fromData).trim() !== '') {
            return String(fromData).trim();
        }

        const fromH2 = $slide.find('h2').first().text();
        return fromH2 && fromH2.trim() ? fromH2.trim() : '';
    }

    const prevTitle = i > 0 ? getSlideTitle(i - 1) : '';
    const nextTitle = i < last ? getSlideTitle(i + 1) : '';

    setArrow($prev, i > 0, prevTitle);
    setArrow($next, i < last, nextTitle);
}

// ===== Inicialización de cada sección =====
function initSection($scope) {
    if ($scope.data('s-init')) return;

    const $img = $scope.find('.VehicleSldr-img .vImgSlides').first();
    const $txt = $scope.find('.VehicleSldr_txt .vTxtSlides').first();
    const $controls = $scope.find('.VehicleSldr_txt .slider-controls');
    const $dotsBox  = $controls.find('.slide-m-dots').empty();

    // Asegura que los botones no arranquen deshabilitados
    $controls.find('.slide-m-prev, .slide-m-next')
        .prop('disabled', false).removeAttr('disabled')
        .removeClass('slick-disabled').attr('aria-disabled', 'false');

    // crear spans de label si no existen
    ensureArrowLabel($controls.find('.slide-m-prev'));
    ensureArrowLabel($controls.find('.slide-m-next'));

    // --- IMÁGENES ---
    if ($img.length && !$img.hasClass('slick-initialized')) {
        $img.slick({
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            lazyLoad: 'progressive',
            adaptiveHeight: true,
            waitForAnimate: false,
            asNavFor: $txt
        });
    }

    // --- TEXTO ---
    if ($txt.length && !$txt.hasClass('slick-initialized')) {
        $txt.slick({
            dots: false,
            arrows: true,
            infinite: false,
            adaptiveHeight: true,
            waitForAnimate: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendDots: $dotsBox,
            prevArrow: $controls.find('.slide-m-prev'),
            nextArrow: $controls.find('.slide-m-next'),
            asNavFor: $img
        })
            .off('.reflow .navstate')
            .on('init.reflow reInit.reflow afterChange.reflow', function () {
                fixTxtHeight($(this));
            })
            .on('init.navstate reInit.navstate afterChange.navstate', function () {
                updateArrowsState($(this), $controls);
            });

        // calcula los labels en el primer render
        setTimeout(() => updateArrowsState($txt, $controls), 0);
    }

    $scope.data('s-init', true);
}

// ===== Wiring por sección =====
function setupFeaturesSection(rootSelector, namespace) {
    function onTabShown() {
        const $visible = $(`${rootSelector} .FeatureContent:visible`);
        if (!$visible.length) return;

        requestAnimationFrame(() => {
            if (!$visible.find('.vTxtSlides').hasClass('slick-initialized')) {
                initSection($visible);
            }
            reflowAndSync($visible);
        });
    }

    if ($(rootSelector).length) {
        $(rootSelector).simpleTab({
            container: '.VehicleSldr-options',
            handler: '.VehicleSldr-options>a',
            content: '.FeatureContent',
            attribute: 'rel',
            namespeace: namespace,
            effect: "class",
            caller: onTabShown
        });

        const $firstVisible = $(`${rootSelector} .FeatureContent:visible`);
        if ($firstVisible.length) {
            initSection($firstVisible);
            reflowAndSync($firstVisible);
        }
    }
}

// ===== Punto de entrada =====
window.Features = function () {
    setupFeaturesSection('.FeaturesExt', 'fext');
    setupFeaturesSection('.FeaturesInt', 'fint');
    setupFeaturesSection('.FeaturesTech', 'ftech');
    setupFeaturesSection('.FeaturesHyb',  'fhyb');
};
